var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"rules":_vm.rules,"no-resize":"","name":"message","label":"Mensagem","solo":""}})}
var staticRenderFns = []

export { render, staticRenderFns }